import {Button} from '@/components/common-components/v2';
import {MetaIdeasType} from '@/store/content-optimizer/aiMetaData';
import {faCopy} from '@fortawesome/pro-light-svg-icons';
import {faCheck} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Divider, Tooltip} from 'antd';
import {useState} from 'react';
import styled from 'styled-components';

interface Props {
  metaIdeas: MetaIdeasType[];
  onIdeaUse: (title: string, desc: string) => void;
}

export const MetaIdeasList = ({metaIdeas, onIdeaUse}: Props) => {
  const [metaCopied, setMetaCopied] = useState(false);

  const copyMetaHandler = (title: string, desc: string) => {
    navigator.clipboard.writeText(`${title}\n${desc}`);
    setMetaCopied(true);
  };

  return <IdeasContainer>
    {metaIdeas?.map((idea, idx) => {
      return <SingleIdeaContainer key={idx}>
        <MetaTitle>{idea.metaTitle}</MetaTitle>
        <MetaDesc>{idea.metaDesc}</MetaDesc>
        <Divider style={{marginTop: 8, marginBottom: 8}}/>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <Tooltip title={metaCopied ? <span><FontAwesomeIcon icon={faCheck} style={{color: '#2AC155', marginRight: 5}}/>{`Meta Details copied.`}</span> : 'Copy Meta Details.'}>
            <FontAwesomeIcon icon={faCopy} onClick={() => copyMetaHandler(idea.metaTitle, idea.metaDesc)} style={{marginTop: 'auto', marginBottom: 'auto', marginLeft: 10, fontSize: 16, cursor: 'pointer'}}/>
          </Tooltip>
          <Button color='purple' variant='ghost' style={{marginRight: 0}} onClick={() => onIdeaUse(idea.metaTitle, idea.metaDesc)}>Use this Suggestion</Button>
        </div>
      </SingleIdeaContainer>;
    })}
  </IdeasContainer>;
};

const IdeasContainer = styled.div`
  max-height: 515px;
  overflow-y: auto;

  // For Internet Explorer
  scrollbar-face-color: rgba(138,138,138,0.32);
  scrollbar-track-color: rgba(138,138,138,0.12);

  // For Google Chrome
  &::-webkit-scrollbar {
    height: 5px;
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(138,138,138,0.32);
  }

  &::-webkit-scrollbar-track {
    background: rgba(138,138,138,0.12);
  }
`;

const SingleIdeaContainer = styled.div`
  border: 1px solid #d2d2d2;
  padding: 14px 10px 11px 11px; 
  border-radius: 4px;
  margin-bottom: 8px;
  margin-right: 10px;
`;
const MetaTitle = styled.div`
 font-size: 12px;
 color: #121212;
 font-weight: 500;
`;
const MetaDesc = styled.div`
font-size: 12px;
color: #4E5156;
`;
